import React, { FC } from 'react';
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { formatTooltipLabel, formatTooltipValue, formatXAxis, formatYAxis } from '../../utils';

interface RevenueChartItem {
  revenue: number;
  month: number;
  year: number;
}

interface Props {
  data: RevenueChartItem[];
  numMonths: number;
}

const DashOrdersRevenue: FC<Props> = ({ data, numMonths }: Props) => {
  const chartData = data.slice(0, numMonths).map((item) => ({
    Revenue: item.revenue,
    name: `${item.year}-${item.month}`,
  }));

  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart
        width={500}
        height={400}
        data={chartData}
        margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 0,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="name"
          reversed
          tick={{ fontFamily: 'sans-serif', fontSize: '14px' }}
          tickFormatter={formatXAxis}
        />
        <YAxis tick={{ fontFamily: 'sans-serif', fontSize: '14px' }} tickFormatter={formatYAxis} />
        <Tooltip
          formatter={formatTooltipValue}
          labelFormatter={formatTooltipLabel}
          wrapperStyle={{ fontFamily: 'sans-serif', fontSize: '14px' }}
        />
        <Area
          dataKey="Revenue"
          fill="#3db67d40"
          isAnimationActive={false}
          stroke="#3db67c"
          strokeWidth={1}
          type="monotone"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default DashOrdersRevenue;
